// eslint-disable-next-line import/prefer-default-export
export const consignmentDocumentQueryKeys = {
  byConsignmentId: (consignmentId: number | null) => ['v3/consignment', consignmentId, 'documents'],
}
